import axios from "axios";
import { host } from "../../../helper/config";
import { getItemPerPage } from "../../../helper/helper";

const PLUGINS_NAME = "admin-classic-tickets";

export const getListClassicInputTicket = async (
  token,
  query,
  page,
  itemPerPage,
) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-list-input-ticket`,
    {
      ...query,
      page: page,
      itemPerPage: itemPerPage || getItemPerPage(),
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

export const updateClassicInputTicket = async (
  token,
  id,
  numbers,
  amount,
  isSingle,
  image,
) => {
  try {
    const formData = new FormData();
    formData.append("id", id);
    formData.append("numbers", numbers);
    formData.append("amount", amount);

    if (image) {
      if (image instanceof File) {
        formData.append("image", image, image.name);
      } else if (
        typeof image === "string" &&
        image.length > 0 &&
        !image.startsWith("http")
      ) {
        const base64Data = image.replace(/^data:image\/\w+;base64,/, "");
        const byteCharacters = atob(base64Data);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "image/jpeg" });
        formData.append("image", blob, "ticket.jpg");
      }
    }

    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/update-numbers`,
      formData,
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "multipart/form-data",
          Authorization: token,
        },
      },
    );

    if (response && response.status === 200) {
      return response.data || {};
    }
    return null;
  } catch (error) {
    console.error("updateClassicInputTicket error:", error);
    return null;
  }
};

export const getListClassicSalesTicket = async (
  token,
  query,
  page,
  itemPerPage,
) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-list-sales-ticket`,
    {
      ...query,
      page: page,
      itemPerPage: itemPerPage || getItemPerPage(),
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

export const getSummaryClassicSalesTicket = async (
  token,
  query,
  page,
  itemPerPage,
) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/get-summary-sales-ticket`,
    {
      ...query,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

export const deleteAllTicket = async (token, inputId) => {
  if (window.confirm("Bạn có muốn xóa tất cả vé không?")) {
    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/delete-all-ticket`,
      {
        inputId: inputId,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );
    if (response && response.status === 200) {
      return true;
    } else {
      return null;
    }
  }

  return null;
};

export const deleteTicket = async (token, storageId) => {
  if (window.confirm("Bạn có muốn xóa vé của dãy số này không?")) {
    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/delete-ticket`,
      {
        storageId: storageId,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );
    if (response && response.status === 200) {
      return true;
    } else {
      return null;
    }
  }

  return null;
};

// Delete multiple tickets at once without confirm dialog (caller handles confirm)
export const deleteMultipleTickets = async (token, storageIds) => {
  try {
    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/delete-multiple-tickets`,
      {
        storageIds: storageIds,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("deleteMultipleTickets error:", error);
    return null;
  }
};

export const updateStatusTicket = async (token, storageId, status) => {
  const actionLabel =
    status === 1
      ? "duyệt"
      : status === 6
        ? "tạm ngưng"
        : status === 0
          ? "đưa về chờ duyệt"
          : "kích hoạt";

  if (
    window.confirm(
      "Bạn có muốn " + actionLabel + " vé của dãy số này không?",
    )
  ) {
    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/update-status-ticket`,
      {
        storageId: storageId,
        status: status,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );
    if (response && response.status === 200) {
      return true;
    } else {
      return null;
    }
  }
  return null;
};

export const updateTicketNumber = async (token, id, number) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/update-ticket-number`,
    {
      id: id,
      number: number,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

export const updateSalesTicket = async (token, id, numbers, amount, images) => {
  const response = await axios.post(
    `${host}/${PLUGINS_NAME}/update-sales-ticket`,
    {
      id: id,
      numbers: numbers,
      amount: amount,
      images: images,
    },
    {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: token,
      },
    },
  );

  if (response && response.status === 200) {
    return response.data || {};
  }
  return null;
};

// Update multiple tickets status at once (for bulk approve/submit)
export const updateMultipleStatusTickets = async (
  token,
  storageIds,
  status,
) => {
  try {
    const response = await axios.post(
      `${host}/${PLUGINS_NAME}/update-multiple-status-tickets`,
      {
        storageIds: storageIds,
        status: status,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: token,
        },
      },
    );
    if (response && response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    console.error("updateMultipleStatusTickets error:", error);
    return null;
  }
};
